import React from 'react';
import CommonWrap from '../common-wrap';


const VideoWrap = () => {
    const tabs = [ { id: '1', tab: '任务视频'},{ id: '2', tab: '稿件视频'} ];
    const title = '视频池';

    return(
        <CommonWrap tabs={tabs} title={title}/>
    )
   
    
}


export default VideoWrap